export default __webpack_public_path__ + "static/media/h_icon1.31b7a98e.png";